import React from "react";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { styles } from "./StatsViews.styles";
import { IStatsFilters } from "../StatsFilter/StatsFilter";
import { useSelector } from "react-redux";
import { StatsTable } from "../StatsTable";
import { IColumnMapping } from "../../../../components/CsvExport/CsvExportButton";
import { convertNumberToDateString } from "../../../../../utilities/dateTimeUtils";
import HierarchicPieChart from "../../../../components/charts/HierarchicPieChart/HierarchicPieChart";

const dataColumns = [
    {
        type: "date",
        title: "Date",
        field: "date"
    },
    {
        type: "text",
        title: "User's id",
        field: "userId"
    },
    {
        type: "text",
        title: "User's email",
        field: "email"
    },
    {
        type: "text",
        title: "Total Sales",
        field: "totalSale"
    },
    {
        type: "text",
        title: "Average Sales",
        field: "avgSale"
    },
    {
        type: "text",
        title: "Number of Orders",
        field: "noTransactions"
    },
    {
        type: "text",
        title: "Number of Order Items",
        field: "noOrderItems"
    },
];

const summaryColumns = [
    {
        type: "text",
        title: "User's id",
        field: "userId"
    },
    {
        type: "text",
        title: "User's email",
        field: "email"
    },
    {
        type: "text",
        title: "Number of Orders",
        field: "salesNumber"
    },
    {
        type: "text",
        title: "Total sales",
        field: "totalSales"
    }
];

const dataExportMapping: IColumnMapping[] = [
    {
        key: "userId",
        label: "User's id"
    },
    {        
        key: "email",
        label: "User's email"
    },
    {
        key: "date",
        label: "Date",
        mappingFunc: value => convertNumberToDateString(value)
        
    },
    {
        key: "totalSale",
        label: "Total Sales",
    },
    {
        key: "avgSale",
        label: "Average Sales",
    },
    {
        key: "noTransactions",
        label: "Number of Orders",
    },
    {
        key: "noOrderItems",
        label: "Number of Order Items"
    }
];

const summaryDataExportMapping: IColumnMapping[] = [
    {
        key: "userId",
        label: "User's id"
    },
    {
        key: "email",
        label: "User's email"
    },
    {
        key: "salesNumber",
        label: "Number of Orders"
    },
    {
        key: "totalSales",
        label: "Total sales"
    }
];
export interface ISalesByUserViewProps extends WithStyles<typeof styles> {
    from?: number;
    to?: number;
    filters?: IStatsFilters;
}

const SalesByUserViewPure: React.FunctionComponent<ISalesByUserViewProps> = ({ from, to, filters, classes }: ISalesByUserViewProps) => {


    const salesByUser = useSelector(state => state.statistics.salesByUser);

    return (
        <>
            <HierarchicPieChart
                data={salesByUser?.data as Array<any>}
                levels={["email"]}
                aggregationOptions="count"
                title="Sales by user"
                showBreadcrumbs={false}
                noLegend={true}
            />
            <StatsTable
                dataColumns={dataColumns}
                summaryColumns={summaryColumns}
                data={salesByUser?.data}
                summaryData={salesByUser?.summary}
                exportFilePrefix={`sales_by_user_from${from}_to_${to}`}
                dataExportMapping={dataExportMapping}
                summaryDataExportMapping={summaryDataExportMapping}
            />
        </>
    );
};

export const SalesByUserView = withStyles(styles)(SalesByUserViewPure);
